import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100dvh',
  width: '100dvw',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    minHeight: '100dvh',
    height: 'auto',
  },
}));

export const StyledContentContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 6,
    padding: 30,
    gap: 20,
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      padding: 10,
    },
  };
});

export const StyledImgContainer = styled('div')({
  backgroundImage:
    'linear-gradient(to right, #0487E6, #46A4E8), ' +
    'linear-gradient(to bottom right, rgba(255, 255, 255, 0) 0%, white 100%), ' +
    'linear-gradient(to bottom right, rgba(255, 255, 255, 0) 0%, white 100%), ' +
    'linear-gradient(to bottom right, rgba(255, 255, 255, 0) 0%, white 100%)',
  backgroundSize: 'cover',
  backgroundBlendMode: 'normal',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 8,
});

interface StyledImgProps {
  $height?: string | number;
  $mt?: string | number;
}
export const StyledImg = styled('img')<StyledImgProps>(({ $height, $mt }) => ({
  position: 'absolute',
  height: $height,
  marginTop: $mt,
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  alignSelf: 'flex-start',
  cursor: 'pointer',
  width: 163,
  marginLeft: 53,
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    marginLeft: 0,
  },
}));

export const StyledFormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  width: '100%',
});
